<template>
	<v-autocomplete
		:loading="isFetching"
		:items="computedItems"
		:search-input.sync="busca"
		item-text="nome"
		item-value="id"
		return-object
		no-filter
		:value="value"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script setup lang="ts">
import CidadeService from '@/services/CidadeService';
import { useQuery } from '@tanstack/vue-query';
import { Cidade } from 'common/types/Cidade';
import { computed, defineComponent, ref } from 'vue';

defineComponent({
	inheritAttrs: true,
})

const { value } = defineProps<{ value: Cidade | undefined }>()

const busca = ref(value && value.nome)

const { data, isFetching } = useQuery({
	queryKey: ['cidades', busca],
	queryFn: async () => {
		const pagina = await CidadeService.findPage({ search: busca.value?.replace(/-/, '') })
		return pagina.items
	},
})

const emit = defineEmits(['update:modelValue']);

const computedItems = computed(() => {
  if (value && value.nome === busca.value) {
	return [value]
  }

  return data.value;
});
</script>